export default "__VITE_ASSET__36621730__"